var _mask, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.6,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_33_4953",
    maskUnits: "userSpaceOnUse",
    x: 8.5,
    y: 6.5,
    width: 7,
    height: 11
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 8.5,
    y: 6.5,
    width: 7,
    height: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63273 11.6788L13.7165 7.63286C13.8956 7.45571 14.186 7.45571 14.3656 7.63286C14.5448 7.81 14.5448 8.09773 14.3656 8.27487L10.6058 11.9998L14.3652 15.7247C14.5443 15.9018 14.5443 16.1896 14.3652 16.3671C14.186 16.5443 13.8952 16.5443 13.716 16.3671L9.63227 12.3212C9.45583 12.1459 9.45583 11.8537 9.63273 11.6788Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63273 11.6788L13.7165 7.63286C13.8956 7.45571 14.186 7.45571 14.3656 7.63286C14.5448 7.81 14.5448 8.09773 14.3656 8.27487L10.6058 11.9998L14.3652 15.7247C14.5443 15.9018 14.5443 16.1896 14.3652 16.3671C14.186 16.5443 13.8952 16.5443 13.716 16.3671L9.63227 12.3212C9.45583 12.1459 9.45583 11.8537 9.63273 11.6788Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63273 11.6788L13.7165 7.63286C13.8956 7.45571 14.186 7.45571 14.3656 7.63286C14.5448 7.81 14.5448 8.09773 14.3656 8.27487L10.6058 11.9998L14.3652 15.7247C14.5443 15.9018 14.5443 16.1896 14.3652 16.3671C14.186 16.5443 13.8952 16.5443 13.716 16.3671L9.63227 12.3212C9.45583 12.1459 9.45583 11.8537 9.63273 11.6788Z",
    strokeWidth: 0.6,
    mask: "url(#path-1-outside-1_33_4953)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevronLeft.66367d3cb12cc3d2f83c7908f6348e58.svg";
export { ForwardRef as ReactComponent };